// extracted by mini-css-extract-plugin
module.exports = {"Topcarousel":"Topcarousel_Topcarousel__2Qurl","carousel-inner":"Topcarousel_carousel-inner__3rLJp"};